import React, { useContext } from "react";
import { KBContext } from "../../Context";
import { isFeatureEnabled } from "../../utils";
import { FTR_KB_NEW_LOGIN } from "../../Constants";
import NewLoginPage from "./NewLoginPage";
import OldLoginPage from "./OldLoginPage";

export default function LoginPage() {
    const { availableFeatures, data: kbData } = useContext(KBContext);
    const kbTenant = (typeof kbData?.tenant === 'string') ? kbData.tenant : null;
    const isOldLoginForced = !kbTenant && availableFeatures?.[FTR_KB_NEW_LOGIN] === false;

    if (isOldLoginForced) {
        return <OldLoginPage />;
    }
    return <NewLoginPage />;
}
